/**
 * 放置/离线系统
 * 处理离线收益计算
 */

import type { PlayerState } from './Player';
import { passiveCultivate } from './Cultivation';

export interface IdleReward {
  /** 离线秒数 */
  elapsedSeconds: number;
  /** 修炼经验收益 */
  expGained: number;
  /** 是否有收益 */
  hasReward: boolean;
  /** 显示消息 */
  message: string;
}

/**
 * 计算离线收益
 */
export function calculateIdleReward(player: PlayerState, now: number): IdleReward {
  const elapsedMs = now - player.lastSaveTime;
  const elapsedSeconds = Math.floor(elapsedMs / 1000);

  // 离线不到 30 秒不计算
  if (elapsedSeconds < 30) {
    return {
      elapsedSeconds: 0,
      expGained: 0,
      hasReward: false,
      message: '',
    };
  }

  const result = passiveCultivate(player, elapsedSeconds);
  player.lastSaveTime = now;

  return {
    elapsedSeconds,
    expGained: result.expGained ?? 0,
    hasReward: result.expGained! > 0,
    message: result.message,
  };
}
